import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Tooltip } from 'bootstrap';
import { Modal } from 'bootstrap';
// import bootstrap, { Tooltip } from 'bootstrap';
import { CommonService } from 'src/app/services/common.service'; 
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit, AfterViewInit {

  monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  currentYear: number = new Date().getFullYear();
  monthsWithDays: Array<Array<any>> = [];
  holidays: any[] = [];

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.generateCalendarData();

    this.getEvents(3, 0, 0, 0); // fetch holidays
  }

  ngAfterViewInit(): void {
    this.initializeTooltips();
  }

  onYearChange(offset: number): void {
    this.currentYear += offset;
    this.generateCalendarData();
    this.initializeTooltips();
  }

  getEvents(flag: number, id: number, pageSize: number, pageNumber: number): void {
    this.commonService.getEvents(flag, id, pageSize, pageNumber).subscribe(
      (response) => {
        if (response.status === 200) {
          this.holidays = response.data || [];
console.log(this.holidays)
          this.generateCalendarData();
          this.initializeTooltips();
        } else {
          console.warn('Holiday fetch failed', response);
        }
      },
      (error) => {
        console.error('API error', error);
      }
    );
  }

  generateCalendarData(): void {
    this.monthsWithDays = [];

    for (let month = 0; month < 12; month++) {
      const days: Array<any> = [];

      const totalDays = new Date(this.currentYear, month + 1, 0).getDate();
      const firstDay = new Date(this.currentYear, month, 1).getDay();
      const startPadding = firstDay === 0 ? 6 : firstDay - 1;

      for (let i = 0; i < startPadding; i++) {
        days.push(null);
      }

      for (let day = 1; day <= totalDays; day++) {
        const dateStr = `${this.currentYear}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const holiday = this.holidays.find(h => h.date === dateStr);

      const currentDate = new Date(this.currentYear, month, day);
 

      days.push({ day, holiday, isSunday: currentDate.getDay() === 0 });
      }

      this.monthsWithDays.push(days);
    }
  }

 selectedHoliday: any = null;
 hasHoliday: boolean = false;

 openHolidayModal(holiday: any) {
    if (holiday) {
    this.selectedHoliday = holiday;
    this.hasHoliday = true;
  } else {
    this.selectedHoliday = null;
    this.hasHoliday = false;
    return; 
  }
    const modalEl = document.getElementById('holidayModal');
    if (modalEl) {
      const modal = new Modal(modalEl); 
      modal.show();
    } else {
      console.error('Modal element not found!');
    }
  }

  initializeTooltips(): void {
    setTimeout(() => {
      const tooltipElements = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipElements.forEach(el => new Tooltip(el));
    });
  }
}
